var render = function render(){var _vm=this,_c=_vm._self._c;return _c('detail',{attrs:{"on-manager":_vm.onManager,"base-info":_vm.baseInfo,"status-module":"rds","data":_vm.data,"resource":"dbinstances","extra-info":_vm.extraInfo,"auto-hidden-columns-key":"rds_hidden_columns"}})
}
var staticRenderFns = []

export { render, staticRenderFns }